import { QuestionOptionsModel } from './questionOptions.model';

export class QuestionsModel {
    Id: number;
    Question: string;
    QuestionType: number;
    QuestionParent: number;
    QuestionParentAnswer: number;
    QuestionCategory: number;
    QuestionAnswer: string;
    QuestionOptions: QuestionOptionsModel[];
    AnswerFreeText: any;
    StartRow: number;
    StartColumn: number;
    EndRow: number;
    EndColumn: number;
    Sequence:number;
    IsMandatory:boolean;
  }
